// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { ITransactionGetByIdResponse } from 'app_types/transaction/transactionTypes'
// @end

class TransactionService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  getById = async (id: string, skipAlert: boolean = false) => {
    this.refreshAuthToken()

    let responseData: ITransactionGetByIdResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/transaction/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else if (!skipAlert) {
      this.screenNotification.fire(responseData)
    }

    return null
  }



}

export default TransactionService
